// 流程图标工具：优先使用自定义图标(iconUrl)，否则按 分类/流程名 关键词映射 Element 图标与配色。
// 发起申请页(WflowApply) 与 申请配置页(WflowApplyConfig) 共用，保证两处图标一致。

export const ICON_RULES = [
  { keys: ['合同', '协议', '用印'], icon: 'el-icon-document', color: '#2f6bff', bg: '#e8f0ff' },
  { keys: ['进销存'], icon: 'el-icon-shopping-cart-2', color: '#2f6bff', bg: '#e8f0ff' },
  { keys: ['采购', '请购', '采买', '进货'], icon: 'el-icon-shopping-cart-2', color: '#f5a623', bg: '#fff3e0' },
  { keys: ['假勤', '考勤', '请假', '加班', '休假', '出差', '外出'], icon: 'el-icon-time', color: '#2f6bff', bg: '#e8f0ff' },
  { keys: ['人事', '人力', '招聘', '离职', '入职', '员工', '培训'], icon: 'el-icon-user', color: '#52c41a', bg: '#eafbe7' },
  { keys: ['行政', '申领', '礼品', '团建'], icon: 'el-icon-office-building', color: '#2f6bff', bg: '#e8f0ff' },
  { keys: ['销售', '客户', '商机'], icon: 'el-icon-suitcase', color: '#2f6bff', bg: '#e8f0ff' },
  { keys: ['财务', '报销', '费用', '付款', '补贴', '奖'], icon: 'el-icon-money', color: '#fa8c16', bg: '#fff4e6' },
  { keys: ['项目'], icon: 'el-icon-folder', color: '#722ed1', bg: '#f4ecff' },
  { keys: ['用车', '车辆'], icon: 'el-icon-location', color: '#13c2c2', bg: '#e6fffb' }
]

export const ICON_DEFAULT = { icon: 'el-icon-s-claim', color: '#2f6bff', bg: '#e8f0ff' }

// 按分类+流程名内容映射默认图标与配色
export function pickIcon(category, flowName) {
  const text = (category || '') + ' ' + (flowName || '')
  return ICON_RULES.find(r => r.keys.some(k => text.indexOf(k) > -1)) || ICON_DEFAULT
}

// 拼接完整图标地址（自定义图标存相对路径，拼接后端基址；已是 http 开头则原样返回）
export function fullIconUrl(iconUrl, baseApi) {
  if (!iconUrl) return ''
  if (/^https?:\/\//i.test(iconUrl)) return iconUrl
  return (baseApi || '') + iconUrl
}
